import React, { Component } from 'react';
import ProgressCircle from  './ProgressCircle';

const subject='order na-u-ra.ru';
const username='mail_robot';
const password='robot';
const url='http://54.93.73.56:8080/pub/mail';
const success='success';
const fail='fail';
//const url='http://localhost:8080/pub/mail';


export default class EmailForm extends Component{

    state={

    };
    constructor(props) {
        super(props);
    }
    validateEmail=(email)=> {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    handleEmailChange=(e) =>{
        const email=e.target.value;
        const isEmailValid=this.validateEmail(email);
        this.setState({email: email,
            isEmailValid:isEmailValid});
        this.props.handler(email);
    };
    handleMessageChange=(e) =>{
        this.setState({message: e.target.value});
    };
    render () {
        return (

            <form className='email-form'>
                {this.getEmailField()}
                <textarea className='msg-input' rows="5" name="message" placeholder="Сообщите службе поддержки удобное время и способ связи." onChange={this.handleMessageChange}>
                    </textarea>
                { this.getBottomElement()}

            </form>);

    };
    getBottomElement=()=>{
        if(this.state.isSending){
            return <ProgressCircle/>;
        }
        if(this.state.sendResult===success){
            return<div className='flex-text-m'> <p>Заявка успешно отправлена. Подтверждение выслано на указанный адрес электронной почты.
                Для повторной отправки обновите страницу.</p></div>
        }
        if(this.state.sendResult===fail && this.state.isEmailValid){
            return <div className='flex-text-m'><p className='light-pink'>Не удалось отправить заявку. Обновите страницу, чтобы повторить попытку.</p></div>
        }
        if(this.state.isEmailValid){
            return   <button className='send-button' type="button" onClick={this.handleSend}>Отправить</button>;
        }
        if(this.state.email){
            return <div className='flex-text-m'><p>Не корректный адрес электронной почты</p></div>
        }
        return <div className='flex-text-m'><p>Введите адрес электронной почты</p></div>
    };
    getEmailField=()=>{
        if(this.state.isEmailValid || !this.state.email){
            return <input className='email-input' type="email" name="email" placeholder="Email" onChange={this.handleEmailChange} />
        }
        return <input className='email-not-valid' type="email" name="email" placeholder="Email" onChange={this.handleEmailChange} />;
    };
    handleSend =() =>{
        const message={
            email:this.state.email,
            subject:subject,
            body:this.state.message,
            username:username,
            password:password
        };
        const xhttp=new XMLHttpRequest();
        xhttp.open("POST", url, true);
        xhttp.setRequestHeader("Content-type", "application/json; charset=utf8");
        xhttp.setRequestHeader( 'Access-Control-Allow-Origin', '*');
        this.setState({isSending: true});
        this.setState({sendResult: undefined});
        xhttp.onreadystatechange = () =>{
            if (xhttp.readyState === xhttp.DONE) {
                console.log(xhttp.status);
                this.setState({isSending: false});
                if (xhttp.status === 200) {
                    console.log(xhttp.response);
                    console.log(xhttp.responseText);
                    const res=xhttp.responseText;
                    if(!res|| JSON.parse(res).value!=='ok'){
                        this.onSendFail();
                        return;
                    }
                    this.setState({sendResult: success});
                }else{
                    this.onSendFail();
                }
            }
        };
        xhttp.send(JSON.stringify(message));

    };

    onSendFail=()=>{
        this.setState({sendResult: fail});
    }
}